export default {
  id: 'vehicle.previousLocation',
  name: 'vehicle.previousLocation',
  displayName: 'Previous location',
  valueType: 'string',
  objectType: 'vehicle',
  blueprint: {},
  get: obj => {
    return obj?.data?.previousLocation?.name || '-';
  }
};